import { PixiBase } from './PixiBase';

export class DrawerBase extends PixiBase {
  constructor() {
    super();
    this._observers = [];
  }

  createApplication() {
    return new this.PIXI.Application({
      transparent: true,
      width: 1440,
      height: 792,
    });
  }

  createContainer(name) {
    const container = new this.PIXI.Container();
    if (name) {
      container.name = name;
    }
    return container;
  }

  createSpine(source) {
    return new this.PIXI.spine.Spine(source.spineData);
  }

  addChildToSlot(slotName, child, index = 0) {
    const slot = this.getSlot(slotName);
    if (slot) {
      (slot.children[index] || slot).addChild(child);
      return true;
    }
    return false;
  }

  getSlot({ texture, name }) {
    const index = texture.spineData.slots.findIndex((slotData) => slotData.name === name);
    return texture.children[index];
  }

  createSprite(source) {
    return new this.PIXI.Sprite(source.texture);
  }

  createLoader() {
    return new this.PIXI.Loader();
  }

  setPosition(element, { x = 0, y = 0 } = {}) {
    element.x = x;
    element.y = y;
  }

  setSizes(element, { w = 0, h = 0 }) {
    element.width = w;
    element.height = h;
  }

  setPivot(element, { x, y }) {
    element.x = x;
    element.y = y;
  }

  createText(text, style) {
    return new this.PIXI.Text(text, style);
  }

  createGraphics() {
    return new this.PIXI.Graphics();
  }

  addSubscriber(obs) {
    this._observers.push(obs);
    return obs;
  }

  destroy() {
    this._observers.forEach((obs) => {
      obs.unsubscribe();
    });
    this._observers = [];
  }

  calculatePosition({ element, containerName, position = { x: 0, y: 0 } }) {
    if (!element.parent) {
      return position;
    }

    if (element.parent.name === containerName) {
      return position;
    }

    const newPosition = {
      x: position.x + element.parent.position.x,
      y: position.y + element.parent.position.y,
    };

    return this.calculatePosition({
      element: element.parent,
      containerName,
      position: newPosition,
    });
  }

  setupButtonMode(texture, { interactive = true, buttonMode = true } = {}) {
    texture.interactive = interactive;
    texture.buttonMode = buttonMode;
  }

  createTextContainer(textList, space = 15) {
    const container = this.createContainer('textContainer');
    const { width } = textList.reduce(
      (acc, element) => {
        element.anchor.set(0.5);
        this.setPosition(element, { x: acc.startX + element.width / 2 });
        acc.width += element.width;
        acc.startX += space + element.width;
        return acc;
      },
      {
        width: space * (textList.length - 1),
        startX: 0,
      }
    );
    container.pivot.x = width / 2;
    container.addChild(...textList);
    return container;
  }

  stopSpine(texture) {
    texture.skeleton.setToSetupPose();
    texture.state.tracks = [];
  }

  registerClick(texture, onClick) {
    return texture.on('pointerdown', onClick);
  }

  registerPointerover(texture, event) {
    return texture.on('pointerover', event);
  }

  registerPointerout(texture, event) {
    return texture.on('pointerout', event);
  }

  registerPointerup(texture, event) {
    return texture.on('pointerup', event);
  }
}
